import { render } from "./Edit.vue?vue&type=template&id=1c2aec8d"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Contacts/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c2aec8d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c2aec8d', __exports__)) {
    console.log('reload')
    api.reload('1c2aec8d', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=1c2aec8d", () => {
    console.log('re-render')
    api.rerender('1c2aec8d', render)
  })

}


export default __exports__